import React from 'react';
import './EntityItem.css';

const EntityItemSkeleton: React.FC = () => {
  return (
    <div className="entity-item animate-pulse cursor-default hover:bg-white dark:hover:bg-slate-800/40 hover:shadow-sm">
      <div className="entity-item__status-container">
        <div className="w-5 h-5 rounded-full bg-light-surfaceSecondary dark:bg-slate-700" />
        <div className="entity-item__status-dot bg-light-surfaceSecondary dark:bg-slate-700 border-none" />
      </div>

      <div className="entity-item__content">
        <div className="entity-item__info">
          <div className="h-2 w-12 bg-light-surfaceSecondary dark:bg-slate-700 rounded mb-2" />
          <div className="h-4 w-3/4 bg-light-surfaceSecondary dark:bg-slate-700 rounded" />
        </div>

        <div className="entity-item__stats">
          <div className="entity-item__stat-group">
            <div className="h-2 w-8 bg-light-surfaceSecondary dark:bg-slate-700 rounded mb-1" />
            <div className="h-3 w-12 bg-light-surfaceSecondary dark:bg-slate-700 rounded" />
          </div>
          <div className="entity-item__stat-group w-16">
            <div className="h-2 w-10 bg-light-surfaceSecondary dark:bg-slate-700 rounded mb-1" />
            <div className="h-3 w-8 bg-light-surfaceSecondary dark:bg-slate-700 rounded" />
          </div>
        </div>

        <div className="entity-item__checkbox">
          <div className="w-4 h-4 rounded bg-light-surfaceSecondary dark:bg-slate-700" />
        </div>
      </div>
    </div>
  );
};

export default EntityItemSkeleton;
